import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

type FormGroupProps = {
  label: string;
  className?: string;
  htmlFor?: string;
};

export const FormGroup = ({ children, label, className, htmlFor }: PropsWithChildren<FormGroupProps>) => {
  return (
    <label htmlFor={htmlFor} className={classNames('block', className)}>
      <div className="mb-2 text-xs">{label}</div>
      {children}
    </label>
  );
};
